module.exports = __webpack_public_path__ + "img/1205352558.e49b4282.jpg";